import MuiTelegram from '@mui/icons-material/Telegram';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type TelegramIconProps = SvgIconProps;

export const TelegramIcon = (props: TelegramIconProps) => {
  return <MuiTelegram {...props} />;
};
